export default __webpack_public_path__ + "static/media/hackerProject.464553e6.png";